import React, { useEffect } from 'react';
import { routes } from '../../main/routes';
import { Breadcrumbs } from '../../library/common/components';
import clock from '../../resources/img/clock.svg';
import whatsapp from '../../resources/img/whatsapp.svg';
import location from '../../resources/img/location.svg';
import mail from '../../resources/img/mail.svg';
import integral from '../../resources/img/services/integral.jpeg';
import { Link } from 'react-router-dom';

const Single = (props) => {
  const crumbs = routes
    .filter(({ path }) => props.match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
          (path, param) => path.replace(
            `:${param}`, props.match.params[param]
          ), path
          )
        : path,
      ...rest
    }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className='services-page'>
    <Breadcrumbs crumbs={crumbs} title={'Nuestros servicios'}/>
    <div className='content'>
      <div className='menu'>
        <div>
          <Link to ='../services'><span>Todos los servicios</span></Link>
          <span className='active'>Reformas integrales</span>
          <Link to ='#'><span>Reforma de cocina</span></Link>
          <Link to ='#'><span>Reforma de baño</span></Link>
          <Link to ='#'><span>Climatización</span></Link>
          <Link to ='#'><span>Locales y oficinas comerciales</span></Link>
          <Link to ='#'><span>Instalación eléctrica</span></Link>
        </div>
        <div className='info'>
          <span className='title'>
            Contáctanos
          </span>
          <div className='option'>
            <strong>Estamos ubicados en</strong>
            <span>
              <a href="http://maps.google.com/?q=Carrer Badajoz 168, 08018, Barcelona">
                <img src={location} />
                Carrer Badajoz 168, 08018, Barcelona
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Info de contacto</strong>
            <span>
              <a href='https://api.whatsapp.com/send?phone=+34555123456' title='Chateemos por whatsapp' target="_blank">
                <img src={whatsapp} />
                +34 555 12 34 56
              </a>
            </span>
            <span>
              <a href='mailto:info@selo.es' title='Envíanos un email' target="_blank">
                <img src={mail} />
                info@selo.es
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Nuestros horarios</strong>
            <span>
              <img className='clock' src={clock} />
              Lun-Sat: 8:00 - 19:00
            </span>
          </div>
        </div>
      </div>
      <div className='body single'>
        <span className='title'>Reformas integrales</span>
        <div className='description'>
          Ofrecemos las mejores soluciones para viviendas, comunidades, locales y oficinas comerciales.<br/>
          Abarcamos todos los trabajos que pueden ser necesarios para realizar una reforma:<br/><br/>
          <ul>
            <li>Albañilería y revestimientos.</li>
            <li>Soldados y alicatados.</li>
            <li>Instalaciones de Fontanería y Saneamiento.</li>
            <li>Instalaciones eléctricas y climatización.</li>
            <li>Carpinterías de aluminio y pvc.</li>
            <li>Pladur y Pinturas.</li>
            <li>Instalacion de suelos en general.</li>
          </ul>
        </div>
        <img src={integral}/>
        <div className='section'>
          <div className='info'>
            <span className='title'>Project management</span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
            in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </div>
          <div className='info'>
            <span className='title'>Reporting and cost control</span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
            in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </div>
        </div>
      </div>
    </div>
  </div>
)};

export default Single;
